// tslint:disable-next-line:no-submodule-imports
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { HTTPMethod } from "../../../model/http-method.enum";
import { HTTPRequestBuilder } from "../../../model/http.request.model";
import { AsyncJobId } from "../../../persistence/dto/async-job-id.model";
import { PagedQueryResult } from "../../../persistence/dto/paged-query-result.model";
import { HTTPService } from "../../../service/http.service";
import { ApiResponse } from "../../models/api-response.model";
import { CampaignProduct } from "../../models/campaign-product.model";
import { StockMaterialDTO } from "../../models/stock-material-dto.model";
import { FileService } from "../../services/file-service";
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { Product, ProductCategory } from "../_models/product";
import { Country } from "../../../model/country.enum";

@Injectable({
    providedIn: "root"
})
export class ProductsService {
    private API_MATERIALS_URL = environment.API_URL + "api/materials";
    private API_MATERIALS_IMPORT_URL = environment.API_URL + "api/materials/import";
    private API_MATERIALS_EXPORT_URL = environment.API_URL + "api/materials/export";

    private API_PRODUCTS_URL = environment.API_URL + "api/products";
    private API_KARDEX_URL = environment.API_URL + "api/kardex";
    private API_PRODUCTS_CATEGORIES_URL = environment.API_URL + "api/productcategories";
    private API_CAMPAIGN_PRODUCTS_URL = environment.API_URL + "api/campaign-products";
    private API_CAMPAIGN_PRODUCTS_ALL_URL = environment.API_URL + "api/campaign-products/all";
    private API_CAMPAIGN_PRODUCTS_WITHOUT_MATERIAL_URL = environment.API_URL + "api/campaign-products/withoutproductmaterial";
    private API_FILE_CAMPAIGN_PRODUCTS_URL = this.API_CAMPAIGN_PRODUCTS_URL + "/upload?campaignId=";
    private API_FILE_CAMPAIGN_PRODUCTS_REPLACE_SUGGEST_URL =
        this.API_CAMPAIGN_PRODUCTS_URL + "/upload-replacement?campaignId=";
    private API_FILE_MATERIALS_URL = this.API_PRODUCTS_URL + "/uploadmaterials";
    private API_FILE_MATERIALS_BASIC_URL = this.API_PRODUCTS_URL + "/uploadmaterialsbasic";
    private API_FILE_MATERIALS_STOCK_URL = this.API_PRODUCTS_URL + "/uploadmaterialsstock";
    private API_FILE_REAL_STOCK_URL = this.API_PRODUCTS_URL + "/uploadmaterialsstockreal";
    private API_FILE_REAL_STOCK_URL_UY = this.API_PRODUCTS_URL + "/uploadmaterialsstockrealuy";

    private API_FILE_PRODUCTS_MATERIALS_URL = this.API_PRODUCTS_URL + "/uploadproductsmaterials";
    private API_FILE_MATERIALS_REPLACE_URL = this.API_PRODUCTS_URL + "/uploadmaterialreplacements";
    private API_PRODUCTS_MATERIALS_URL = this.API_PRODUCTS_URL + "/materials";
    private API_PRODUCTS_STRUCTURE_EXCEL_EXPORT_URL = environment.API_URL + "api/productgroups/downloadproducts";
    private API_PRODUCTS_STRUCTURE_EXCEL_IMPORT_URL = environment.API_URL + "api/productgroups/uploadproducts";
    private API_PRODUCTS_EXCEL_EXPORT_URL = environment.API_URL + "api/Products/downloadproducts";
    private API_PRODUCTS_EXCEL_IMPORT_URL = environment.API_URL + "api/Products/uploadproducts";
    private API_MATERIAL_REPLACEMENT_URL = environment.API_URL + "api/Products/materialreplacement";

    constructor(
        private http: HttpClient,
        private fileService: FileService,
        private httpUtils: HttpUtilsService,
        private httpService: HTTPService) { }

    findProducts(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        const url = this.API_PRODUCTS_URL + "/find";
        return this.http.post<QueryResultsModel>(url, queryParams, {
            headers: httpHeaders
        });
    }

    findCampaignProducts(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        const url = this.API_CAMPAIGN_PRODUCTS_URL + "/find";
        return this.http.post<QueryResultsModel>(url, queryParams, {
            headers: httpHeaders
        });
    }

    getProductsByCampaign(idCmp): Observable<CampaignProduct[]> {
        return this.http.get<CampaignProduct[]>(this.API_CAMPAIGN_PRODUCTS_URL + "?campaignId=" + idCmp);
    }

    importExcel(element, idCmp) {
        return this.fileService.fileUpload(element, this.API_FILE_CAMPAIGN_PRODUCTS_URL + idCmp);
    }

    importMaterials(element) {
        return this.fileService.fileUpload(element, this.API_FILE_MATERIALS_URL);
    }

    importMaterialsBasic(element) {
        return this.fileService.fileUpload(element, this.API_FILE_MATERIALS_BASIC_URL);
    }

    importMaterialsPiqueo(element): Observable<ApiResponse> {
        return this.fileService.fileUpload(element, this.API_MATERIALS_IMPORT_URL);
    }

    importMaterialsStock(element) {
        return this.fileService.fileUpload(element, this.API_FILE_MATERIALS_STOCK_URL);
    }

    importRealStock(element) {
        if (environment.country == Country.URUGUAY) {
            return this.fileService.fileUpload(element, this.API_FILE_REAL_STOCK_URL_UY);
        }
        return this.fileService.fileUpload(element, this.API_FILE_REAL_STOCK_URL);
    }

    importProductsMaterials(element) {
        return this.fileService.fileUpload(element, this.API_FILE_PRODUCTS_MATERIALS_URL);
    }

    importMaterialsReplace(element) {
        return this.fileService.fileUpload(element, this.API_FILE_MATERIALS_REPLACE_URL);
    }

    exportExcel(campaignId: string): Observable<any> {
        const url = `${this.API_CAMPAIGN_PRODUCTS_URL}/download?campaignId=${campaignId}`;

        return this.http.get(url, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );
    }

    importExcelReplaceSuggest(element, idCmp) {
        return this.fileService.fileUpload(element, this.API_FILE_CAMPAIGN_PRODUCTS_REPLACE_SUGGEST_URL + idCmp);
    }

    exportExcelReplaceSuggest(campaignId: string): Observable<any> {
        const url = `${this.API_CAMPAIGN_PRODUCTS_URL}/download-replacements?campaignId=${campaignId}`;

        return this.http.get(url, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );
    }

    exportMaterials(campaignId?): Observable<any> {
        const url = `${this.API_PRODUCTS_URL}/downloadmaterials`;

        if (campaignId) {
            return this.http.get(url + "?campaignId=" + campaignId, { responseType: "blob" }).pipe(
                map((res) => {
                    return new Blob([res], { type: "application/vnd.ms-excel" });
                })
            );
        } else {
            return this.http.get(url, { responseType: "blob" }).pipe(
                map((res) => {
                    return new Blob([res], { type: "application/vnd.ms-excel" });
                })
            );
        }
    }

    exportMaterialsBasic(campaignId?): Observable<any> {
        const url = `${this.API_PRODUCTS_URL}/downloadmaterialsbasic`;

        if (campaignId) {
            return this.http.get(url + "?campaignId=" + campaignId, { responseType: "blob" }).pipe(
                map((res) => {
                    return new Blob([res], { type: "application/vnd.ms-excel" });
                })
            );
        } else {
            return this.http.get(url, { responseType: "blob" }).pipe(
                map((res) => {
                    return new Blob([res], { type: "application/vnd.ms-excel" });
                })
            );
        }
    }

    exportMaterialsPiqueo(campaignId: number): Observable<HttpResponse<Blob>> {
        return this.http.get(`${this.API_MATERIALS_EXPORT_URL}?campaignId=${campaignId}`, {
            observe: "response",
            responseType: "blob"
        });
    }

    exportMaterialsStock(campaignId?): Observable<any> {
        const url = `${this.API_PRODUCTS_URL}/downloadmaterialsstock`;

        if (campaignId) {
            return this.http.get(url + "?campaignId=" + campaignId, { responseType: "blob" }).pipe(
                map((res) => {
                    return new Blob([res], { type: "application/vnd.ms-excel" });
                })
            );
        } else {
            return this.http.get(url, { responseType: "blob" }).pipe(
                map((res) => {
                    return new Blob([res], { type: "application/vnd.ms-excel" });
                })
            );
        }
    }

    exportMaterialsStockWithoutPoints(campaignId?): Observable<any> {
        const url = `${this.API_PRODUCTS_URL}/downloadmaterialsstockwithoutpoints`;

        if (campaignId) {
            return this.http.get(url + "?campaignId=" + campaignId, { responseType: "blob" }).pipe(
                map((res) => {
                    return new Blob([res], { type: "application/vnd.ms-excel" });
                })
            );
        } else {
            return this.http.get(url, { responseType: "blob" }).pipe(
                map((res) => {
                    return new Blob([res], { type: "application/vnd.ms-excel" });
                })
            );
        }
    }

    exportRealStock(campaignId?): Observable<any> {
        let url = `${this.API_PRODUCTS_URL}/downloadmaterialsstockreal`;

        if (environment.country == Country.URUGUAY) {
            url = `${this.API_PRODUCTS_URL}/downloadmaterialsstockrealuy`;
        }

        if (campaignId) {
            return this.http.get(url + "?campaignId=" + campaignId, { responseType: "blob" }).pipe(
                map((res) => {
                    return new Blob([res], { type: "application/vnd.ms-excel" });
                })
            );
        } else {
            return this.http.get(url, { responseType: "blob" }).pipe(
                map((res) => {
                    return new Blob([res], { type: "application/vnd.ms-excel" });
                })
            );
        }
    }

    exportProductsMaterials(): Observable<any> {
        const url = `${this.API_PRODUCTS_URL}/downloadproductsmaterials`;

        return this.http.get(url, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );
    }

    exportFailsCode(data) {
        const url = `${this.API_PRODUCTS_URL}/downloadRealStockFail`;
        return this.http.post(url, data, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], {
                    type: "application/vnd.ms-excel"
                });
            })
        );
    }

    exportMaterialsReplace(): Observable<any> {
        const url = `${this.API_PRODUCTS_URL}/downloadmaterialreplacements`;

        return this.http.get(url, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );
    }

    exportNoStockProducts(campaignId): Observable<any> {
        const url = `${this.API_PRODUCTS_URL}/downloadnostockproducts`;

        return this.http.get(url + "/" + campaignId, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );
    }

    exportFirstAndResetOrders(campaignId, zoneId): Observable<any> {
        if (!zoneId) {
            zoneId = 0
        }
        const url = `${this.API_PRODUCTS_URL}/downloadFirstAndResetOrdersPostInvoicing`;
        return this.http.get(url + "?campaignId=" + campaignId + "&zoneId=" + zoneId, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );
    }

    exportFirstAndResetOrdersTrafic(campaignId, zoneId): Observable<any> {
        if (!zoneId) {
            zoneId = 0
        }
        const url = `${this.API_PRODUCTS_URL}/downloadFirstAndResetOrders`;
        return this.http.get(url + "?campaignId=" + campaignId + "&zoneId=" + zoneId, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );
    }

    /**
     * @description
     *	Descargar reporte Fox, para la campaña especificada, de forma
     *	asincrónica.
     */
    public exportFoxProducts(campaignId: number): Observable<AsyncJobId> {
        return this.httpService.send<typeof undefined, AsyncJobId>(
            new HTTPRequestBuilder<typeof undefined>()
                .method(HTTPMethod.GET)
                .controllerPath("api/products")
                .relativePath(`downloadInvoicedFoxProducts/${campaignId}`)
                .build())
            .pipe(map((response) => AsyncJobId.from(response)));
    }

    // READ
    getAllProducts(): Observable<Product[]> {
        return this.http.get<Product[]>(this.API_PRODUCTS_URL);
    }

    // CREATE =>  POST: add a new product to the server
    createProduct(product): Observable<any> {
        return this.http.post<any>(this.API_PRODUCTS_URL, product);
    }

    createCampaignProduct(product): Observable<any> {
        return this.http.post<any>(this.API_CAMPAIGN_PRODUCTS_URL, product);
    }

    updateCampaignProduct(product): Observable<any> {
        return this.http.put<any>(`${this.API_CAMPAIGN_PRODUCTS_URL}/${product.id}`, product);
    }

    getProductCategories(): Observable<ProductCategory[]> {
        return this.http.get<ProductCategory[]>(this.API_PRODUCTS_CATEGORIES_URL);
    }

    updateProduct(product, id) {
        product.id = id;
        return this.http.put<any>(`${this.API_PRODUCTS_URL}/${id}`, product);
    }

    deleteProduct(id: any) {
        return this.http.delete<any>(`${this.API_PRODUCTS_URL}/${id}`);
    }

    activateProduct(id: any) {
        return this.http.post<any>(`${this.API_PRODUCTS_URL}/reactivate/${id}`, null);
    }

    uploadImage(productId: number, fileToUpload: File, imageType: string): Observable<any> {
        const url = `${this.API_PRODUCTS_URL}/imageupload/${productId}`;
        const formData: FormData = new FormData();
        formData.append("file", fileToUpload, fileToUpload.name);
        return this.http.post(url, formData);
    }

    getProductsMaterials(data): Observable<PagedQueryResult<StockMaterialDTO>> {
        return this.http.post(this.API_PRODUCTS_MATERIALS_URL, data)
            .pipe(
                map((data: PagedQueryResult<StockMaterialDTO>) => {
                    return data
                })
            );
    }

    deleteCampaignProduct(product: any) {
        return this.http.delete(`${this.API_CAMPAIGN_PRODUCTS_URL}/${product.id}`);
    }

    deleteProductMaterial(id: any) {
        return this.http.delete<any>(`${this.API_PRODUCTS_MATERIALS_URL}/${id}`);
    }

    getProductsByCampaignAll(campaignId: string) {
        return this.http.get<CampaignProduct[]>(this.API_CAMPAIGN_PRODUCTS_ALL_URL + "/" + campaignId);
    }

    getProductsByCampaignWithoutMaterial(campaignId: string) {
        return this.http.get<CampaignProduct[]>(this.API_CAMPAIGN_PRODUCTS_WITHOUT_MATERIAL_URL + "/" + campaignId);
    }

    getCampaignProductItem(productId: string) {
        return this.http.get<CampaignProduct>(this.API_CAMPAIGN_PRODUCTS_URL + "/" + productId);
    }

    exportProductsStructure(id): Observable<any> {
        const url = `${this.API_PRODUCTS_STRUCTURE_EXCEL_EXPORT_URL}/${id}`;

        return this.http.get(url, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );
    }

    importProductsStructure(element, id) {
        return this.fileService.fileUpload(element, `${this.API_PRODUCTS_STRUCTURE_EXCEL_IMPORT_URL}/${id}`);
    }

    exportProducts() {
        const url = `${this.API_PRODUCTS_EXCEL_EXPORT_URL}`;

        return this.http.get(url, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );
    }

    importProducts(element) {
        return this.fileService.fileUpload(element, `${this.API_PRODUCTS_EXCEL_IMPORT_URL}`);
    }

    deleteMaterial(id: number) {
        return this.http.delete(`${this.API_MATERIAL_REPLACEMENT_URL}/${id}`);
    }

    /**
    * @description
    *	Descargar abastecimiento de forma asincrónica.
    */
    public exportStockProjection(date?): Observable<AsyncJobId> {
        return this.httpService.send<typeof undefined, AsyncJobId>(
            new HTTPRequestBuilder<typeof undefined>()
                .method(HTTPMethod.GET)
                .controllerPath("api/campaigns/projection-report")
                .relativePath(`${date ? date : ''}`)
                .build())
            .pipe(map((response) => AsyncJobId.from(response)));
    }

    exportKardex(dateFrom, dateTo): Observable<any> {
        const url = `${this.API_KARDEX_URL}/downloadstockmateriallog`;

        return this.http.get(url + "?dateFrom=" + dateFrom + "&dateTo=" + dateTo, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );

    }

    exportKardexReal(dateFrom, dateTo): Observable<any> {
        const url = `${this.API_KARDEX_URL}/downloadrealstockmateriallog`;

        return this.http.get(url + "?dateFrom=" + dateFrom + "&dateTo=" + dateTo, { responseType: "blob" }).pipe(
            map((res) => {
                return new Blob([res], { type: "application/vnd.ms-excel" });
            })
        );

    }
}
